module.exports = __webpack_public_path__ + "static/media/app-store.52d6ed33.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/app-store.svg
// module id = 477
// module chunks = 11